import { Navigate, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GetCurrentUserDocument } from '@/graphql/getCurrentUser.api';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { data, loading } = useQuery(GetCurrentUserDocument, {
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!data?.currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
